import lodash from "lodash";

export const removeEmptyValue = (object: any) => {
  return lodash.omitBy(
    object,
    (v: any) => lodash.isUndefined(v) || lodash.isNull(v) || v === "",
  );
};
